/**
 * ZportiWordmark — the "zporti" logotype from the onboarding design: a light→purple
 * gradient "zport" with the dot of the "i" drawn as the Zporti ball (purple stalk +
 * glowing yellow ball). Rendered as a single inline SVG so it looks identical on web
 * and native. `textLength` fixes the "zport" width so the ball-"i" lands deterministically
 * regardless of the platform font. react-native-svg ignores `textLength` on native, so the
 * text is also end-anchored at the same edge — whatever its natural width, the "t" always
 * ends at x=112 and the gap to the ball-"i" stays constant on every platform.
 */

import { SvgXml } from 'react-native-svg';

/** Intrinsic aspect of the SVG viewBox below. */
const VIEW_W = 156;
const VIEW_H = 58;

const WORDMARK_XML = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${VIEW_W} ${VIEW_H}">
  <defs>
    <linearGradient id="zpText" x1="0" y1="0" x2="0.7" y2="1">
      <stop offset="0.1" stop-color="#F7FAFC"/>
      <stop offset="0.55" stop-color="#D8CCFB"/>
      <stop offset="1" stop-color="#A78BFA"/>
    </linearGradient>
    <linearGradient id="zpBar" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#D8CCFB"/>
      <stop offset="1" stop-color="#A78BFA"/>
    </linearGradient>
  </defs>
  <text x="112" y="45" text-anchor="end" textLength="112" lengthAdjust="spacingAndGlyphs"
    font-family="system-ui, -apple-system, Roboto, 'Segoe UI', sans-serif"
    font-size="46" font-weight="800" letter-spacing="-1.5" fill="url(#zpText)">zport</text>
  <rect x="118" y="16" width="5" height="29" rx="2.5" fill="url(#zpBar)"/>
  <circle cx="120.5" cy="9" r="9" fill="#FCD34D" opacity="0.28"/>
  <circle cx="120.5" cy="9" r="5.5" fill="#FCD34D"/>
</svg>
`;

interface ZportiWordmarkProps {
  /** Rendered height in px; width scales to keep the logotype's aspect ratio. */
  height?: number;
}

export function ZportiWordmark({ height = 46 }: ZportiWordmarkProps) {
  const width = Math.round(height * (VIEW_W / VIEW_H));
  return <SvgXml xml={WORDMARK_XML} width={width} height={height} />;
}
